import { render, staticRenderFns } from "./AssetsHistory.vue?vue&type=template&id=2880ccc7&scoped=true&"
import script from "./AssetsHistory.vue?vue&type=script&lang=js&"
export * from "./AssetsHistory.vue?vue&type=script&lang=js&"
import style0 from "./AssetsHistory.vue?vue&type=style&index=0&id=2880ccc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880ccc7",
  null
  
)

export default component.exports